import { z } from "zod";

const abstractDetailsSchema = z.object({
  abstractLeftTemplate: z.string(),
  abstractRightTemplate: z.string(),
  isAbstractRatingEnabled: z.boolean(),
  isAbstractQaEnabled: z.boolean(),
});

type AbstractDetailsFormData = z.infer<typeof abstractDetailsSchema>;

export { abstractDetailsSchema };
export type { AbstractDetailsFormData };
